import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { LANGUAGES } from "@/lib/languages";

export default function LanguageSelect({ value, onChange, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="bg-white/5 border-white/10 text-white h-[42px] rounded-xl text-sm">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent className="bg-[#0b1220] border-white/10 text-white max-h-72">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code}>{l.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
